//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        readonly: {
            default: false
        },
        comment: {
            default: ''
        },
        instance: {
            default: 'default'
        }
    },

    data: function data() {
        return {
            loading: false,
            loadingCart: true,
            initialized: false,
            userComment: '',
            voucherCode: '',
            voucherCodeError: "",
            voucherValue: 0,
            items: {},
            chargeItems: {},
            freeItems: {},
            data: {
                tax: '0',
                total: '0',
                shippingCost: '0',
                shippingCostNumber: '0',
                voucher: "",
                subtotal: '0',
                subtotalVat: '0',
                discountValueForProducts: '0',
                discountValue: '0',
                fullPrice: '0',
                orderValue: '0'
            }
        };
    },
    created: function created() {
        var _this = this;

        new Form({ instance: this.instance }).post('/api/cart/content').then(function (response) {
            _this.items = response.items;
            _this.chargeItems = response.chargeItems;
            _this.freeItems = response.freeItems;
            _this.data = response.data;
            _this.voucherCode = response.data.voucher.code;
            _this.voucherValue = response.data.voucher.discount_value;
            _this.initialized = true;
            _this.$emit('onLoad', _this.items);
            _this.loadingCart = false;
        });

        App.event.listen('cart.updated', function (response) {
            _this.items = response.items, _this.freeItems = response.freeItems;
            _this.data = response.data;
            _this.voucherCode = response.data.voucher.code;
            _this.voucherValue = response.data.voucher.discount_value;
        });
    },


    computed: {
        subtotal: function subtotal() {
            return parseFloat(this.data.fullPrice).toFixed(2).replace('.', ',');
        },
        tax: function tax() {
            this.data.tax = this.data.fullPrice * 1.19 - this.data.fullPrice;
            return parseFloat(this.data.tax).toFixed(2).replace('.', ',');
        },
        orderValue: function orderValue() {
            this.data.orderValue = parseFloat(this.data.total) - parseFloat(this.data.shippingCost);
            return parseFloat(this.data.orderValue).toFixed(2);
        },
        subtotalVat: function subtotalVat() {
            this.data.subtotalVat = parseFloat(this.data.fullPrice) + parseFloat(this.data.tax) - parseFloat(this.data.discountValue);
            if (this.data.subtotalVat < 0) {
                this.data.subtotalVat = 0;
            }
            return parseFloat(this.data.subtotalVat).toFixed(2).replace('.', ',');
        },
        discountValueForProducts: function discountValueForProducts() {
            this.data.discountValueForProducts = parseFloat(this.data.fullPrice) - parseFloat(this.data.subtotal);
            this.data.discountValueForProducts = parseFloat(this.data.discountValueForProducts).toFixed(2) * 1.19;
            return parseFloat(this.data.discountValueForProducts).toFixed(2).replace('.', ',');
        },
        discountValue: function discountValue() {
            this.data.discountValue = parseFloat(this.data.fullPrice) - parseFloat(this.data.subtotal);
            this.data.discountValue = parseFloat(this.data.discountValue).toFixed(2) * 1.19;
            this.data.discountValue = parseFloat(this.data.discountValue) + parseFloat(this.voucherValue);
            return parseFloat(this.data.discountValue).toFixed(2).replace('.', ',');
        },
        shippingCost: function shippingCost() {
            if (this.data.shippingCost != 0) {
                return this.data.shippingCost.toFixed(2).replace('.', ',');
            } else {
                return 0;
            }
        },
        shippingCostNumber: function shippingCostNumber() {
            return this.data.shippingCost;
        },
        total: function total() {
            this.data.total = parseFloat(this.data.subtotalVat) + parseFloat(this.data.shippingCost);

            return parseFloat(this.data.total).toFixed(2).replace('.', ',');
        },
        link: function link() {
            return App.url;
        },
        empty: function empty() {
            return this.initialized && Object.keys(this.items).length === 0;
        },
        totalsSpan: function totalsSpan() {
            return this.readonly ? 1 : 2;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/cart/components/Cart.vue
// module id = ORnw
// module chunks = 4